// removed by extract-text-webpack-plugin
module.exports = {"productCardContainer":"productCardContainer__nnjU-","rightContainer":"rightContainer__JE6CU","seperator":"seperator__1yA4T","productName":"productName__213u6","merchantLogo":"merchantLogo__mECFj","tag":"tag__3vnVk","productImageStyle":"productImageStyle__28Ert"};


//////////////////
// WEBPACK FOOTER
// ./routes/campaign-activation/componentsVMerchant/productCard/style.css
// module id = FbuU
// module chunks = 458